import service from '@/utils/axios';

//投研栏目列表
export function investResearchList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/investResearch/list',
        method: 'post',
        params: data
    })
}
//团队列表
export function irTeamList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/irTeam/list',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/investTeam.js